import { SentimentName } from 'v2/core/entities/fields';
import { MatchedFeedbackMetadataCommon } from 'v2/core/entities/labels';
import { UUID } from 'v2/core/entities/uuid';

export interface MatchedFeedbackMetadataForAudio
  extends MatchedFeedbackMetadataCommon {
  startTime: number;
  endTime: number;
}

export enum AudioHighlightMetadataType {
  TrackedKeyword = 'tracked-keyword',
  Reason = 'reason',
  Search = 'search',
  KeywordSummary = 'keyword-summary',
  ReasonSummary = 'reason-summary',
}

export interface CommonAudioHighlightMetadata {
  labelID: UUID;
  labelDisplayName: string;
  msgIndex: number;
  startTime: number;
  endTime: number;
}

export interface TrackedKeywordAudioHighlightMetadata
  extends CommonAudioHighlightMetadata {
  type: AudioHighlightMetadataType.TrackedKeyword;
  sentiment: SentimentName;
}

export interface ReasonAudioHighlightMetadata
  extends CommonAudioHighlightMetadata {
  type: AudioHighlightMetadataType.Reason;
}

export interface SearchAudioHighlightMetadata
  extends CommonAudioHighlightMetadata {
  type: AudioHighlightMetadataType.Search;
}

export interface CommonSummaryAudioHighlightMetadata {
  summaryText: string;
  summaryIndex: number;
  summaryCount: number;
}

export interface KeywordSummaryAudioHighlightMetadata
  extends CommonAudioHighlightMetadata,
    CommonSummaryAudioHighlightMetadata {
  type: AudioHighlightMetadataType.KeywordSummary;
  sentiment: SentimentName;
}

export interface ReasonSummaryAudioHighlightMetadata
  extends CommonAudioHighlightMetadata,
    CommonSummaryAudioHighlightMetadata {
  type: AudioHighlightMetadataType.ReasonSummary;
  keywordID: UUID;
}

export type AudioHighlightMetadata =
  | TrackedKeywordAudioHighlightMetadata
  | ReasonAudioHighlightMetadata
  | SearchAudioHighlightMetadata
  | KeywordSummaryAudioHighlightMetadata
  | ReasonSummaryAudioHighlightMetadata;
